import { FC, useEffect, useState } from 'react';
import { Tooltip } from 'react-tooltip';
import { Loader } from '@shared/uikit/loader';
import { IMainIndicatorsFilter } from 'pages/Main/components/Filter';
import LeftClientListPopup from 'pages/Main/components/LeftHashRate/ClientListPopup';
import LeftClientAccountListPopup from 'pages/Main/components/LeftHashRate/ClientAccountListPopup';
import Shield from '@shared/uikit/shield';
import { Link, useNavigate } from 'react-router-dom';
import PercentageMonitor from '@shared/uikit/percentage-monitor';
import { useBoeingLeftAccounts } from '@app/queries/boeing/useBoeingLeftAccounts';
import { IHostingIndicatorsFilter } from '@pages/Hosting/filter';
import { IClientsIndicator } from '@entities/hosting/IClientsIndicator';
import { useClientsIndicator } from '@app/queries/hosting/useClientsIndicator';

interface IProps {
  filter: IHostingIndicatorsFilter;
}

export const HostingLostIndicator: FC<IProps> = ({ filter }) => {
  const navigate = useNavigate();
  const clientsIndicatorFetcher = useClientsIndicator();

  const [data, setData] = useState<any | null>(null);
  const [isCountActive, setCountActive] = useState<boolean>(true);
  const [isKwhActive, setKwhActive] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      if (null === filter) return;

      const clientsData = await clientsIndicatorFetcher.fetch(filter);
      setData({
        hosting: 150,
        hosting_diff: -8,
        wholesale: 100,
        wholesale_diff: -4,
        retail: 47,
        retail_diff: -2,
      });
    })();
  }, [filter]);

  return (
    <>
      <div
        className="p-[20px] border solid rounded-[16px] border-[#959595] border-opacity-30 w-full cursor-pointer"
        onClick={() => navigate('/hosting/list')}
      >
        <div className="text-[#777777] flex justify-between items-center mb-[10px]">
          <span>Потеря Хостинги | Клиенты</span>
          <div className="flex items-center gap-[3px] text-[12px]">
            <div
              onClick={() => {
                setCountActive(true);
                setKwhActive(false);
              }}
              className={` ${isCountActive ? 'bg-[#373539] text-white opacity-0' : ''} flex items-center h-[20px] px-[6px] border border-[#373539] rounded-[16px] border-opacity-80 opacity-80`}
            >
              ед
            </div>
            <div
              onClick={() => {
                setCountActive(false);
                setKwhActive(true);
              }}
              className={` ${isKwhActive ? 'bg-[#373539] text-white opacity-0' : ''} flex items-center h-[20px] px-[6px] border border-[#373539] rounded-[16px] border-opacity-80 opacity-80`}
            >
              мВт
            </div>
          </div>
        </div>

        {!clientsIndicatorFetcher.isPending && data ? (
          <div className="flex justify-between">
            <div>
              <div className="flex items-center gap-[4px]">
                <div className="text-[28px]">
                  {data.hosting !== null && data.hosting !== undefined ? data.hosting : '-'}
                </div>
                <div className="text-[14px]">
                  <span
                    className={`${data.hosting_diff > 0 ? 'text-[#29A70F]' : 'text-[red]'} flex gap-[5px] items-center`}
                  >
                    {(data.hosting_diff > 0 ? '+' : '') + data.hosting_diff}
                  </span>
                </div>
              </div>
              <div className="text-[10px] text-white rounded-[8px] px-[10px] bg-[#211F24] text-center">
                Общее
              </div>
            </div>
            <div>
              <div className="flex items-center gap-[4px]">
                <div className="text-[28px]">
                  {data.retail !== null && data.retail !== undefined ? data.retail : '-'}
                </div>
                <div className="text-[14px]">
                  <span
                    className={`${data.retail_diff > 0 ? 'text-[#29A70F]' : 'text-[red]'} flex gap-[5px] items-center`}
                  >
                    {(data.retail_diff > 0 ? '+' : '') + data.retail_diff}
                  </span>
                </div>
              </div>
              <div className="text-[10px] text-white rounded-[8px] px-[10px] bg-[#211F24] text-center">
                Розница
              </div>
            </div>
            <div>
              <div className="flex items-center gap-[4px]">
                <div className="text-[28px]">
                  {data.wholesale !== null && data.wholesale !== undefined ? data.wholesale : '-'}
                </div>
                <div className="text-[14px]">
                  <span
                    className={`${data.wholesale_diff > 0 ? 'text-[#29A70F]' : 'text-[red]'} flex gap-[5px] items-center`}
                  >
                    {(data.wholesale_diff > 0 ? '+' : '') + data.wholesale_diff}
                  </span>
                </div>
              </div>
              <div className="text-[10px] text-white rounded-[8px] px-[10px] bg-[#211F24] text-center">
                Опт
              </div>
            </div>
          </div>
        ) : (
          <Loader size={45} loading={true} padding="9px" />
        )}
      </div>
    </>
  );
};
